Text of the choice displayed to the candidate.

This must be unique across all choices in the question.
